<script>
  import { factorKey } from './stores.js';

  function switchFactor(factor) {
    // console.log(factor);
    factorKey.set(factor);
    // highlightFacilityId.set(null);
  }
</script>

<!-- climate factors -->
<div class="climate-factors right-bg pb2 bb bw-1px b--mid-gray w-100">
  <ul class="tl list pv0 ph3 mv2 white ttu TI">
    <li
      class="pb1 flex items-center pointer"
      on:click={switchFactor.bind(null, 'heat_risk_rating')}
    >
      <div
        class="dib mr2 off-filter flex items-center justify-center"
        style="background-color: #DD2E2A"
      >
        <div
          class="bg-black h1 w1 br-100 {$factorKey === 'heat_risk_rating'
            ? 'vis'
            : 'hidden'}"
        />
      </div>
      Heat Risk
    </li>
    <li
      class="pv1 flex items-center pointer"
      on:click={switchFactor.bind(null, 'wildfire_risk_rating')}
    >
      <div
        class="dib mr2 off-filter flex items-center justify-center"
        style="background-color: #FFB800"
      >
        <div
          class="bg-black br-100 h1 w1 {$factorKey === 'wildfire_risk_rating'
            ? 'vis'
            : 'hidden'}"
        />
      </div>
      Wildfire Risk
    </li>
    <li
      class="pt1 flex items-center pointer"
      on:click={switchFactor.bind(null, 'flood_risk_rating')}
    >
      <div
        class="dib mr2 off-filter flex items-center justify-center"
        style="background-color: #4492F7"
      >
        <div
          class="bg-black br-100 h1 w1 {$factorKey === 'flood_risk_rating'
            ? 'vis'
            : 'hidden'}"
        />
      </div>
      Flood Risk
    </li>
  </ul>
</div>

<!-- climate factors -->
<style>
</style>
